import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import AppShell from "@/components/AppShell";
import PortalHub from "@/pages/PortalHub";
import NetworkCircuit from "@/pages/network/NetworkCircuit";
import ToolsStudio from "@/pages/tools/ToolsStudio";
import WatchDashboard from "@/pages/viewers/WatchDashboard";
import WatchContent from "@/pages/viewers/WatchContent";
import Workstation from "@/pages/streamers/Workstation";
import Dashboard from "@/pages/Dashboard";
import Pipeline from "@/pages/Pipeline";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import CRM from "@/pages/CRM";
import InboxThread from "@/pages/InboxThread";
import BrandChat from "@/pages/BrandChat";
import Analytics from "@/pages/Analytics";
import AIAssistant from "@/pages/AIAssistant";
import MyProfile from "@/pages/MyProfile";
import Pricing from "@/pages/Pricing";
import PublicCreator from "@/pages/PublicCreator";
import "@/App.css";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-black"><div className="mono text-kinetic animate-pulse">LOADING INDIEWOOD…</div></div>;
  if (!user) return <Navigate to="/" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/u/:slug" element={<PublicCreator />} />
      <Route path="/m/:token" element={<BrandChat />} />
      <Route path="/app" element={<Protected><AppShell /></Protected>}>
        <Route index element={<PortalHub />} />
        <Route path="profile" element={<MyProfile />} />
        <Route path="pricing" element={<Pricing />} />
        {/* Portal ① Viewers */}
        <Route path="watch" element={<WatchDashboard />} />
        <Route path="watch/:id" element={<WatchContent />} />
        {/* Portal ② Streamers */}
        <Route path="studio" element={<Workstation />} />
        {/* Portal ③ Networking */}
        <Route path="network" element={<NetworkCircuit />} />
        {/* Portal ⑤ Tools */}
        <Route path="tools" element={<ToolsStudio />} />
        {/* Portal ④ Influencer Factory */}
        <Route path="factory" element={<Dashboard />} />
        <Route path="factory/profile" element={<MyProfile />} />
        <Route path="factory/pipeline" element={<Pipeline />} />
        <Route path="factory/projects" element={<Projects />} />
        <Route path="factory/projects/:id" element={<ProjectDetail />} />
        <Route path="factory/inbox" element={<CRM />} />
        <Route path="factory/inbox/:id" element={<InboxThread />} />
        <Route path="factory/analytics" element={<Analytics />} />
        <Route path="factory/ai" element={<AIAssistant />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster theme="dark" position="bottom-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
